<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">任务配置</h1>
    <el-row class="user-options">
      <label> 任务类型:</label>
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="taskTypeId"
        placeholder=""
        clearable
      >
        <el-option
          v-for="(item, itemIndex) in taskTypeIds"
          :key="itemIndex"
          :label="item.name"
          :value="item.taskIndex"
        ></el-option>
      </el-select>
      <label>任务名： </label>
      <el-input
        style="width: 160px"
        v-model="taskName"
        placeholder="任务名"
        clearable
      ></el-input>
      <label> 国家:</label>
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="countryCode"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in countryList"
          :key="itemIndex"
          :label="item.country"
          :value="item.countryCode"
        ></el-option>
      </el-select>
      <label> 代理码:</label>
      <el-input style="width: 160px" v-model="agentId"></el-input>
      <label>渠道： </label>
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="channel"
        placeholder="选择渠道"
        clearable
        filterable
      >
        <el-option
          v-for="(item, itemIndex) in channelList"
          :key="itemIndex"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <label> 主播等级:</label>
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="hostLevel"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in hostLevels"
          :key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-row>
    <el-row class="user-options">
      <label>状态： </label>
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="taskStatus"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in taskStatuss"
          :key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <label>面向： </label>
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="gender"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in genderList"
          :key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="warning" @click="getDayChatDetai" :loading="login1">
        查询
      </el-button>
      <el-button type="success" @click="cre"> 创建 </el-button>
      <el-button type="success" @click="clone_box_show = true">
        克隆
      </el-button>
    </el-row>
    <!-- 创建弹窗 -->
    <el-drawer
      :title="msg ? '修改' : '创建'"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <div class="add">
        <el-row>
          <el-col class="el-cols">
            <span>时间:</span>
            <el-date-picker
              style="width: 300px"
              v-model="list.upTime"
              type="datetimerange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>任务:</span>
            <el-select
              style="width: 160px"
              class="header-item"
              @change="name(list.taskTypeId)"
              v-model="list.taskTypeId"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in taskTypeIdss"
                :key="itemIndex"
                :label="item.name"
                :value="item.taskIndex"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>任务名:</span>
            <el-input
              style="width: 160px"
              v-model="list.taskName"
              placeholder="请输入内容"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>类型:</span>
            <el-select
              style="width: 160px"
              class="header-item"
              disabled
              v-model="list.gender"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in genderList"
                :key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>排序值:</span>
            <el-input
              style="width: 160px"
              v-model="list.orderNum"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>渠道:</span>
            <el-select
              style="width: 160px"
              class="header-item"
              :multiple="!msg"
              collapse-tags
              @change="channelChange"
              v-model="list.channel"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in channelList"
                :key="itemIndex"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>描述:</span>
            <el-input
              type="textarea"
              :rows="2"
              style="width: 160px"
              v-model="list.taskDesc"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>国家:</span>
            <el-select
              v-if="!msg"
              style="width: 160px"
              class="header-item"
              multiple
              collapse-tags
              @change="kon"
              v-model="list.countryCode"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in countryList"
                :key="itemIndex"
                :label="item.country"
                :value="item.countryCode"
              ></el-option>
            </el-select>
            <el-select
              v-if="msg"
              style="width: 160px"
              class="header-item"
              v-model="list.countryCode"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in countryList"
                :key="itemIndex"
                :label="item.country"
                :value="item.countryCode"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>代理码:</span>
            <el-input
              style="width: 160px"
              v-model="list.agentId"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>等级:</span>
            <el-select
              style="width: 160px"
              class="header-item"
              v-model="list.hostLevel"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in hostLevels"
                :key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>充值金额:</span>
            <el-input
              style="width: 160px"
              v-model="list.minBossPoints"
              placeholder="请输入正整数"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>充值次数:</span>
            <el-input
              style="width: 160px"
              v-model="list.minRechargeTimes"
              placeholder="请输入正整数"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否有A面教材:</span>
            <el-select
              style="width: 160px"
              class="header-item"
              v-model="list.hasAFace"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in hasAFaceList"
                :key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>状态:</span>
            <el-select
              style="width: 160px"
              class="header-item"
              v-model="list.taskStatus"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in taskStatuss"
                :key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>关联ID:</span>
            <el-input
              style="width: 160px"
              v-model="list.dataId"
              type="number"
              placeholder="关联ID"
            ></el-input>
          </el-col>
        </el-row>
        <el-row class="buttom">
          <el-button type="primary" v-if="!msg" @click="establish()"
            >创建</el-button
          >
          <el-button type="primary" v-if="msg" @click="establish(1)"
            >修改</el-button
          >
        </el-row>
      </div>
    </el-drawer>
    <!-- 表格 -->
    <el-row>
      <el-table
        height="60vh"
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        border
      >
        <!-- 任务类型，那gender -->

        <el-table-column prop="gender" label="任务类型" align="center">
          <template slot-scope="scope">
            {{
              taskTypeIds.filter(
                (item) => item.taskIndex === scope.row.taskTypeId
              )[0].name
            }}
          </template>
        </el-table-column>
        <el-table-column prop="taskName" label="任务名" align="center" />
        <el-table-column prop="taskTypeId" label="任务类型id" align="center" />
        <el-table-column prop="taskDesc" label="描述" align="center" />
        <el-table-column prop="channel" label="渠道" align="center" />
        <el-table-column prop="countryCode" label="国家码" align="center" />
        <el-table-column prop="agentId" label="代理码" align="center" />
        <el-table-column prop="hostLevel" label="主播等级" align="center">
          <template slot-scope="scope">
            {{ scope.row.hostLevel == -1 ? 'all' : scope.row.hostLevel }}
          </template>
        </el-table-column>
        <el-table-column prop="orderNum" label="排序值" align="center" />
        <el-table-column prop="minBossPoints" label="充值金额" align="center" />
        <el-table-column
          prop="minRechargeTimes"
          label="充值次数"
          align="center"
        />
        <el-table-column prop="hasAFace" label="是否有A面教材" align="center">
          <template slot-scope="scope">
            {{
              hasAFaceList.filter(
                (item) => item.value === scope.row.hasAFace
              )[0].label
            }}
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="面向用户类型" align="center">
          <template slot-scope="scope">
            {{
              genderList.filter((item) => item.value === scope.row.gender)[0]
                .label
            }}
          </template>
        </el-table-column>
        <el-table-column prop="dataId" label="关联ID" align="center">
        </el-table-column>
        <el-table-column prop="taskStatus" label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.taskStatus == '0' ? '无效' : '有效' }}
          </template>
        </el-table-column>
        <el-table-column prop="upTime" label="上架时间" align="center">
          <template slot-scope="scope">
            {{ format_(scope.row.upTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="downTime"
          label="下架时间"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            {{ format_(scope.row.downTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="nodeRewards"
          label="任务奖励节点"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button type="primary" @click="modify_(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="130">
          <template slot-scope="scope">
            <el-button type="primary" @click="modify(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 创建弹窗 -->
    <el-dialog :visible.sync="drawers" width="80%" :before-close="handleClose_">
      <div class="add">
        <el-row>
          <el-button type="success" @click="cre_"> 创建 </el-button>
        </el-row>
        <el-row>
          <el-table
            height="60vh"
            :data="dayChatDetailData_"
            style="width: 100%"
            v-loading="login1"
            border
          >
            <el-table-column
              prop="nodeDesc"
              label="任务节点详情"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="curNode" label="节点值" align="center">
            </el-table-column>
            <el-table-column prop="needProcess" label="达成条件" align="center">
            </el-table-column>
            <el-table-column prop="mtime" label="修改时间" align="center">
              <template slot-scope="scope">
                {{ format_(scope.row.mtime) }}
              </template>
            </el-table-column>
            <el-table-column prop="operator" label="操作人" align="center">
            </el-table-column>
            <el-table-column label="奖励列表" align="center" width="180px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  @click="operateReward(1, scope.row.id, scope.row.awards)"
                  size="mini"
                  >奖励详情</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="180px">
              <template slot-scope="scope">
                <el-button
                  type="warning"
                  @click="modify_1(scope.row)"
                  size="mini"
                  >修改</el-button
                >
                <el-button type="danger" @click="dele(scope.row)" size="mini"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="drawers_"
      width="500px"
      :before-close="handleClose_1"
    >
      <div class="add">
        <el-row>
          <el-col class="el-cols">
            <span>节点值:</span>
            <el-input
              type="number"
              style="width: 160px"
              v-model="buil.curNode"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>达成条件:</span>
            <el-input
              type="number"
              style="width: 160px"
              v-model="buil.needProcess"
              placeholder="请输入内容"
            ></el-input>
            <span>tip:填数字</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>任务节点详情:</span>
            <el-input
              type="text"
              style="width: 160px"
              v-model="buil.nodeDesc"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-row>
      </div>
      <div class="buttom_">
        <el-button
          type="primary"
          v-if="!msgs"
          :loading="lading_a"
          @click="establish_()"
          >创建</el-button
        >
        <el-button
          type="primary"
          v-if="msgs"
          :loading="lading_a"
          @click="establish_(1)"
          >修改</el-button
        >
      </div>
    </el-dialog>

    <!-- 奖励弹窗 -->
    <el-dialog
      :visible.sync="rewardDrwer"
      width="50%"
      :before-close="handleClose_reward"
    >
      <div class="add">
        <el-row>
          <el-button type="success" @click="operateReward(2)"> 创建 </el-button>
        </el-row>
        <el-row>
          <el-table
            height="60vh"
            :data="awardListById"
            style="width: 100%"
            v-loading="login1"
            border
          >
            <el-table-column prop="awardDesc" label="奖品描述" align="center">
            </el-table-column>
            <el-table-column prop="awardNum" label="奖品数量" align="center">
            </el-table-column>
            <el-table-column prop="bigIcon" label="奖励图标" align="center">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.bigIcon !== ''"
                  style="width: 100px; height: 100px"
                  :src="scope.row.bigIcon"
                  :preview-src-list="[scope.row.bigIcon]"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="180px">
              <template slot-scope="scope">
                <el-button
                  type="warning"
                  @click="operateReward(3, scope.row.relateId, scope.row)"
                  size="mini"
                  >修改</el-button
                >
                <el-button
                  type="danger"
                  @click="operateReward(5, scope.row.relateId)"
                  size="mini"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="rewardDrwer1"
      width="800px"
      :before-close="handleClose_reward1"
    >
      <div class="add">
        <el-row>
          <el-col class="el-cols">
            <span>奖品id:</span>
            <!-- <el-select style="width: 160px" class="header-item" v-model="rewardOne.awardId" placeholder="">
              <el-option v-for="(item, itemIndex) in awardbaselist" :key="itemIndex" :label="item.awardDesc"
                :value="item.id"></el-option>
            </el-select> -->
            <el-table
              :data="awardbaselist"
              :header-cell-style="{ background: '#F8F8F9' }"
              style="width: 100%; margin-top: 20px"
              height="440px"
            >
              <el-table-column label="选择" align="center" width="65">
                <template scope="scope">
                  <!--  @change.native="getCurrentRow(scope.row)" -->
                  <el-radio :label="scope.row.id" v-model="rewardOne.awardId">{{
                    ''
                  }}</el-radio>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="奖品名"
              ></el-table-column>
              <el-table-column align="center" prop="icon" label="图标">
                <template scope="scope">
                  <el-image
                    style="width: 50px; height: 50px"
                    :src="scope.row.icon"
                    :preview-src-list="[scope.row.icon]"
                  >
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="bigIcon" label="大图标">
                <template scope="scope">
                  <el-image
                    style="width: 50px; height: 50px"
                    :src="scope.row.bigIcon"
                    :preview-src-list="[scope.row.bigIcon]"
                  >
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="unitPrice"
                label="单价"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="awardDesc"
                label="描述"
              ></el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>奖品数量:</span>
            <el-input-number
              v-model="rewardOne.awardNum"
              label="请输入数量"
            ></el-input-number>
            <!-- <el-input type="number" style="width: 160px" v-model="rewardOne.awardNum" placeholder="请输入内容"></el-input> -->
            <!-- <span>tip:填数字</span> -->
          </el-col>
        </el-row>
      </div>
      <div class="buttom_">
        <el-button
          type="primary"
          :loading="lading_a"
          @click="operateReward(4)"
          >{{ addOrEdit ? '创建' : '修改' }}</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="clone_box_show"
      width="30%"
      title="克隆"
      :before-close="handleClose_clone"
    >
      <el-form :model="clone_form" label-width="120px">
        <el-form-item label="源渠道" prop="fromChannel">
          <el-select
            filterable
            v-model="clone_form.fromChannel"
            placeholder="请选择源渠道"
          >
            <el-option
              v-for="item in channelList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标渠道" prop="toChannel">
          <el-select
            filterable
            v-model="clone_form.toChannel"
            placeholder="请选择目标渠道"
          >
            <el-option
              v-for="item in channelList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否强制克隆" prop="force">
          <el-radio-group v-model="clone_form.force">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clone_box_show = false">取 消</el-button>
        <el-button type="primary" @click="clone">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { allChannelList, allRewardList } from '@/utils/normalApi.js'
export default {
  data() {
    return {
      clone_box_show: false,
      lading_a: false,
      id: '',
      msg: false,
      taskTypeIds: [],
      taskTypeId: -1,
      hostLevel: -1,
      agentId: 'all',
      hostLevels: [
        {
          label: 'all',
          value: -1,
        },
        {
          label: 'L0',
          value: 0,
        },
        {
          label: 'L1',
          value: 1,
        },
        {
          label: 'L2',
          value: 2,
        },
        {
          label: 'L3',
          value: 3,
        },
      ],
      hasAFaceList: [
        {
          label: 'all',
          value: -1,
        },
        {
          label: '有',
          value: 1,
        },
        {
          label: '没有',
          value: 0,
        },
      ],
      genderList: [
        {
          label: 'all',
          value: -1,
        },
        {
          label: '用户',
          value: 1,
        },
        {
          label: '主播',
          value: 2,
        },
      ],
      gender: 2,
      taskStatus: 1,
      taskStatuss: [
        {
          label: '无效',
          value: 0,
        },
        {
          label: '有效',
          value: 1,
        },
      ],
      orderNums: [
        {
          value: 1,
        },
        {
          value: 2,
        },
        {
          value: 3,
        },
        {
          value: 4,
        },
      ],
      countryCode: 'all',
      agentCode: 'all',
      countryList: [],
      channelList: [],
      agentList: [],
      channel: '',
      taskName: '',
      drawer: false,
      drawers: false,
      drawers_: false,
      direction: 'rtl',
      // 加载
      login1: false,
      list: {
        taskTypeId: -1,
        hostLevel: -1,
        taskStatus: 1,
        countryCode: ['all'],
        orderNum: '',
        taskDesc: '',
        taskName: '',
        upTime: ['', ''],
        channel: ['all'],
        minBossPoints: 0,
        minRechargeTimes: 0,
        hasAFace: -1,
        gender: 2,
        dataId: 0,
        agentId: "all",
      },
      taskTypeIdss: [],
      // 表格数据
      dayChatDetailData: [],
      dayChatDetailData_: [],
      msgs: false,
      rewardTypes: [{ label: '钻石', value: 1 }],
      buil: {
        curNode: '',
        needProcess: '',
        valid: 1,
        nodeDesc: '',
      },
      //奖励列表
      rewardDrwer: false,
      rewardDrwer1: false,
      addOrEdit: true,
      awardbaselist: [],
      awardListById: [],
      rewardOne: {
        id: '',
        taskNodeId: '',
        awardId: '',
        awardNum: '',
      },
      clone_form: {
        fromChannel: '',
        toChannel: '',
        force: '0',
      },
    }
  },
  async created() {
    this.getDayChatDetai()
    this._getCountry()
    this.channelList = await allChannelList()
    if (this.channelList.length > 0)
      this.channelList.unshift({ value: 'all', name: 'all' })
    this._get()
  },
  methods: {
    handleClose_clone() {
      this.clone_form = {
        fromChannel: '',
        toChannel: '',
        force: '0',
      }
      this.clone_box_show = false
    },
    async clone_() {
      const url = `${this.$store.getters.path.config_clone}?username=${this.$store.getters.username}&token=${this.$store.getters.token}`
      const data = {
        fromChannel: this.clone_form.fromChannel,
        toChannel: this.clone_form.toChannel,
        force: this.clone_form.force == 1,
      }
      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success('success')
      this.clone_box_show = false
      this.getDayChatDetai()
    },
    clone() {
      if (
        this.clone_form.fromChannel === '' ||
        this.clone_form.toChannel === ''
      ) {
        this.$message.error('请选择源渠道和目标渠道')
        return
      }
      // 如果强制克隆，提示弹窗二次确认
      if (this.clone_form.force === '1') {
        this.$confirm(
          '强制克隆会覆盖目标渠道已有的任务配置，是否继续？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            this.clone_()
          })
          .catch(() => {})
      } else {
        this.clone_()
      }
    },
    cre_() {
      this.drawers_ = true
      this.msgs = false
      this.buil = {
        rewardType: 1,
        taskInfoId: this.id,
        curNode: '',
        needProcess: '',
        rewardCount: 1,
        valid: 1,
      }
    },
    fotime(tiem) {
      let date = new Date(tiem)
      let time1 = date.getTime() / 1000
      return time1
    },
    name(naem) {
      this.taskTypeIds.map((ele) => {
        if (ele.taskIndex == naem) {
          this.list.taskName = ele.name
          this.list.orderNum = ele.order
          this.list.gender = ele.gender
        }
      })
    },
    kon(countryCode) {
      countryCode.map((ele) => {
        if (ele == 'all') {
          this.list.countryCode = ['all']
        }
      })
    },
    channelChange(val) {
      if (val.length == 2 && val[0] == 'all') {
        return (this.list.channel = [val[1]])
      }
      if (val[val.length - 1] == 'all') this.list.channel = ['all']
    },
    async _getCountry() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.CountryList,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res !== null) {
        this.countryList = res.data.countryList
        this.countryList.unshift({
          country: 'all',
          countryCode: 'all',
        })
      }
    },
    async _get() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.config_valid_list,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res !== null) {
        this.taskTypeIds = res.data
        this.taskTypeIds.unshift({
          taskIndex: -1,
          name: 'all',
        })
        this.taskTypeIdss = this.taskTypeIds.slice(1)
      }
    },
    format_(data) {
      let date = new Date(data * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    // 查询列表
    async getDayChatDetai() {
      let url =
        this.$store.getters.path.config_all_list +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        taskStatus: this.taskStatus,
        taskTypeId: this.taskTypeId,
        countryCode: this.countryCode,
        hostLevel: this.hostLevel,
        gender: this.gender,
        channel: this.channel,
        taskName: this.taskName,
        agentId: this.agentId,
      }
      this.login1 = true
      const { data: res } = await this.$axios.post(url, data)
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data
    },
    // 创建
    async establish(num) {

      let url
      let data
      if (num == 1) {
        url =
          this.$store.getters.path.config_info_update +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        data = {
          id: this.id,
          taskTypeId: this.list.taskTypeId,
          hostLevel: this.list.hostLevel,
          taskStatus: this.list.taskStatus,
          countryCode: this.list.countryCode,
          orderNum: this.list.orderNum,
          taskDesc: this.list.taskDesc,
          taskName: this.list.taskName,
          channel: this.list.channel,
          gender: this.list.gender,
          dataId: this.list.dataId,
          minBossPoints: this.list.minBossPoints,
          minRechargeTimes: this.list.minRechargeTimes,
          hasAFace: this.list.hasAFace,
          upTime: this.fotime(this.list.upTime[0]),
          downTime: this.fotime(this.list.upTime[1]),
          operator: this.$store.getters.username,
          agentId: this.list.agentId,
        }
      } else {
        url =
          this.$store.getters.path.config_batch_create +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        data = {
          taskTypeId: this.list.taskTypeId,
          hostLevel: this.list.hostLevel,
          taskStatus: this.list.taskStatus,
          countryCode: this.list.countryCode.join(','),
          orderNum: this.list.orderNum,
          taskDesc: this.list.taskDesc,
          taskName: this.list.taskName,
          channel: this.list.channel.join(','),
          gender: this.list.gender,
          minBossPoints: this.list.minBossPoints,
          minRechargeTimes: this.list.minRechargeTimes,
          dataId: this.list.dataId,
          hasAFace: this.list.hasAFace,
          upTime: this.fotime(this.list.upTime[0]),
          downTime: this.fotime(this.list.upTime[1]),
          operator: this.$store.getters.username,
          agentId: this.list.agentId,
        }
      }

      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.handleClose()
      this.getDayChatDetai()
    },
    // 创建
    async establish_(num) {
      this.lading_a = true
      let url
      let data
      if (num == 1) {
        url =
          this.$store.getters.path.config_node_update +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        data = {
          id: this.buil.id,
          curNode: this.buil.curNode,
          needProcess: Number(this.buil.needProcess),
          nodeDesc: this.buil.nodeDesc,
          operator: this.$store.getters.username,
        }
      } else {
        url =
          this.$store.getters.path.config_node_create +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        data = {
          taskInfoId: this.id,
          curNode: this.buil.curNode,
          needProcess: Number(this.buil.needProcess),
          valid: this.buil.valid,
          nodeDesc: this.buil.nodeDesc,
          operator: this.$store.getters.username,
        }
      }

      const { data: res } = await this.$axios.post(url, data)
      this.lading_a = false
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.drawers = false
      this.drawers_ = false
      this.getDayChatDetai()
    },
    cre() {
      this.drawer = true
      this.msg = false
      this.list.countryCode = []
      this.list.taskTypeId = ''
    },
    // 修改
    modify(row) {
      this.msg = true
      this.list = {
        taskTypeId: row.taskTypeId,
        hostLevel: row.hostLevel,
        taskStatus: row.taskStatus,
        countryCode: row.countryCode,
        orderNum: row.orderNum,
        taskDesc: row.taskDesc,
        taskName: row.taskName,
        channel: row.channel,
        minBossPoints: row.minBossPoints,
        minRechargeTimes: row.minRechargeTimes,
        hasAFace: row.hasAFace,
        dataId: row.dataId,
        gender: row.gender,
        agentId: row.agentId,
        upTime: [this.format_(row.upTime), this.format_(row.downTime)],
      }
      this.id = row.id
      this.drawer = true
    },
    modify_(row) {
      this.drawers = true
      this.dayChatDetailData_ = row.nodeRewards || []
      this.id = row.id
    },
    modify_1(row) {
      this.drawers_ = true
      this.msgs = true
      this.buil = {
        curNode: row.curNode,
        needProcess: row.needProcess,
        nodeDesc: row.nodeDesc,
        valid: 1,
        id: row.id,
      }
    },
    async dele(row) {
      let url =
        this.$store.getters.path.config_node_del +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        id: row.id,
        operator: this.$store.getters.username,
      }
      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.message)
      this.drawers = false
      this.drawers_ = false
      this.getDayChatDetai()
    },
    async operateReward(type, id, row) {
      // 获取奖励列表
      this.awardbaselist = await allRewardList(1099)
      if (type == 1) {
        this.rewardDrwer = true
        this.awardListById = row
        this.rewardOne.taskNodeId = id
      } else if (type == 2 || type == 3) {
        this.rewardDrwer1 = true
        this.addOrEdit = type == 2
        if (type == 3) {
          this.rewardOne.id = id
          this.rewardOne.awardId = row.awardId
          this.rewardOne.awardNum = row.awardNum
        }
      } else if (type == 4) {
        let url
        let data = {
          awardId: this.rewardOne.awardId,
          awardNum: this.rewardOne.awardNum,
          operator: this.$store.getters.username,
        }
        if (this.addOrEdit) {
          url =
            this.$store.getters.path.config_reward_create +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
          data.taskNodeId = this.rewardOne.taskNodeId
        } else {
          url =
            this.$store.getters.path.config_reward_update +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
          data.id = this.rewardOne.id
        }
        const { data: res } = await this.$axios.post(url, data)
        this.handleClose_1()
        this.handleClose_()
        this.handleClose_reward2()
        this.getDayChatDetai()
        if (res.code != 0) return this.$message.error(res.msg)
      } else if (type == 5) {
        let url =
          this.$store.getters.path.config_reward_del +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        let data = {
          id: id,
          operator: this.$store.getters.username,
        }
        const { data: res } = await this.$axios.post(url, data)
        this.handleClose_1()
        this.handleClose_()
        this.handleClose_reward2()
        this.getDayChatDetai()
        if (res.code != 0) return this.$message.error(res.message)
      }
    },

    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    },
    handleClose() {
      this.list = {
        taskTypeId: -1,
        hostLevel: -1,
        taskStatus: 1,
        countryCode: ['all'],
        orderNum: '',
        taskDesc: '',
        taskName: '',
        upTime: ['', ''],
        channel: ['all'],
        minBossPoints: 0,
        minRechargeTimes: 0,
        hasAFace: -1,
        gender: 2,
        dataId: 0,
        agentId:'all'
      }
      this.drawer = false
    },
    handleClose_() {
      this.drawers = false
    },
    handleClose_1() {
      this.drawers_ = false
    },
    handleClose_reward() {
      this.rewardDrwer = false
    },
    handleClose_reward1() {
      this.rewardDrwer1 = false
      this.rewardOne.awardId = ''
      this.rewardOne.awardNum = ''
    },
    handleClose_reward2() {
      this.rewardDrwer = false
      this.rewardDrwer1 = false
      this.awardbaselist = []
      this.awardListById = []
      this.rewardOne = {
        id: '',
        taskNodeId: '',
        awardId: '',
        awardNum: '',
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;
    display: flex;

    >* {
      margin: 0 4px;
    }

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}

.add {
  .el-row {
    padding: 0 30px;

    span {
      display: block;
      margin: 0 0 10px;
    }

    .el-input {
      width: 150px;
    }

    > .el-cols {
      display: flex;
      align-items: center;

      > span {
        width: 80px;
      }
    }
  }

  .buttom {
    display: flex;
    justify-content: flex-end;
    margin: 0 100px;
  }
}

.buttom_ {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
label{
  display:flex;
  align-items:center;
}
</style>
